import { render, staticRenderFns } from "./RiskCheckCheckLogAll.vue?vue&type=template&id=4ed7fd25&scoped=true"
import script from "./RiskCheckCheckLogAll.vue?vue&type=script&lang=js"
export * from "./RiskCheckCheckLogAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed7fd25",
  null
  
)

export default component.exports